import { useRouter } from 'vue-router'

export const useRefreshStore = defineStore('refresh', () => {
  const refreshPage = ref<string[]>([]); // 刷新页面的列表
  // 关闭详情页面后返回之前打开的列表
  const pathRecords = ref<any>([])

  /**
   * 添加需要刷新的路由
   * @param 
   * @returns
   */
  const setRefreshPath = (path:string) => {
    refreshPage.value.push(path)
  };

  /**
   * 当前页面是否刷新
   * @param 
   * @returns
   */
  const isRefresh = () : boolean => {
    let path_now = useRouter().currentRoute.value.path
    return refreshPage.value.includes(path_now)
  };

  /**
   * 清除完成删除操作的路由
   * @param 
   * @returns
   */
  const clearRefreshPage = () => {
    let path_now = useRouter().currentRoute.value.path
    let index = refreshPage.value.indexOf(path_now)
    if(index !== -1){
      refreshPage.value.splice(index,1)
    }
  };

  /**
   * 设置路径记录
   * @param 
   * @returns
   */
  const setPathRecords = (to:any, from:any) => {
    for (let i = 0; i < pathRecords.value.length; i++) {
      const item = pathRecords.value[i];
      if(item.to.fullPath === to.fullPath) return
      if(item.to.path === to.path) {
        pathRecords.value[i] = {
          to,
          from
        }
        return 
      }
    }
    pathRecords.value.push({ to, from })
  };

  /**
   * 核对并返回来源页
   * @param 
   * @returns
   */
  const checkAndBack = (path:any) => {
    let formPath = null
    for (let i = 0; i < pathRecords.value.length; i++) {
      const item = pathRecords.value[i];
      if(item.to.fullPath === path.fullPath) {
        formPath = item.from
        pathRecords.value.splice(i,1)
        break
      }
    }
    return formPath
  }

  /**
   * 清除路径记录
   * @param 
   * @returns
   */
  const clearPathRecords = (path:any) => {
    pathRecords.value = pathRecords.value.filter((item:any) => item.to.fullPath !== path.fullPath)
  }

  return {
    refreshPage,
    pathRecords,
    setRefreshPath,
    isRefresh,
    clearRefreshPage,
    setPathRecords,
    checkAndBack,
    clearPathRecords
  };
});

export default useRefreshStore;
